import ACCOUNT_ROUTES from './account-routes';

/**
 * @note: When removing items from this map, we also need to revisit our NewRelic drop rules.
 * @see: https://varsity.atlassian.net/jira/software/c/projects/SOS/issues/SOS-121
 */
const EXTERNAL_ROUTES: Record<string, string> = {
  [ACCOUNT_ROUTES.membership]: '/account/client/x/membership/plans',
  [ACCOUNT_ROUTES.activity]: '/account/client/x/activity',
  // [ACCOUNT_ROUTES.payment]: '/account/client/x/payment', not built yet
  [ACCOUNT_ROUTES.settings]: '/account/client/x/settings',
};

export default EXTERNAL_ROUTES;
